var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","height":"40px"},on:{"click":function($event){return _vm.SignIn()}}},[_c('v-icon',{staticStyle:{"font-size":"30px"},attrs:{"color":"primary"}},[_vm._v("mdi-microsoft-azure")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }